import { graphql } from '../../__generated__';

export const AVAILABLE_WITHDRAWAL_AMOUNT = graphql(`
  query AvailableWithdrawalAmount {
    availableWithdrawalAmount {
      currentWithdrawalGbp
    }
  }
`);
